import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	adSectionTitle: {
		id: 'issue-view-foundation.quick-add.ad-control-section.ad-section-title',
		defaultMessage: 'Recommended for you',
		description: 'Title of the Ad Crossflow section in quick actions list.',
	},
});
